import { ENV, Environment } from './env';

const isProd = ENV === Environment.PROD;

const AZURE_CLIENT_ID = import.meta.env.REACT_APP_AUTH_CLIENT_ID || '';
const AZURE_EXTRA_SCOPE = `api://${AZURE_CLIENT_ID}/Road_Safety_Academy_${isProd ? 'Prod' : 'Dev'}`;
// const GOOGLE_DOMAINS = ['unfpa.org', 'unops.org', 'anvileight.com', 'kellton.com'];

export { AZURE_CLIENT_ID, AZURE_EXTRA_SCOPE };
